import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import { queueArticleRender } from "../../articleRenderQueue";
import type { Article } from "../wikidaily/types";
import type { DuelGamePayload, DuelPlayerInfo } from "./types";

type DuelLocalState = {
  currentArticle: Article | null;
  connectionError: string | null;
  queueStatus: "searching" | null;
  playerInfos: Record<string, DuelPlayerInfo>;
};

type DuelStore = {
  gameState: DuelGamePayload | null;
  localState: DuelLocalState;

  update_game: (state: DuelGamePayload) => void;
  queue_status: (payload: { state: "searching" }) => void;
  article_loaded: (payload: { article: Article; html: string }) => void;
  player_info: (payload: DuelPlayerInfo) => void;
  setConnectionError: (error: string | null) => void;
};

export const useDuelsStore = create<DuelStore>()(
  immer((set) => ({
    gameState: null,
    localState: {
      currentArticle: null,
      connectionError: null,
      queueStatus: null,
      playerInfos: {},
    },

    update_game: (state) => {
      set((draft) => {
        draft.gameState = state;
        draft.localState.queueStatus = null;
        draft.localState.connectionError = null;
      });
    },

    queue_status: (payload) => {
      set((draft) => {
        draft.gameState = null;
        draft.localState.queueStatus = payload.state;
        draft.localState.connectionError = null;
      });
    },

    article_loaded: ({ article, html }) => {
      set((draft) => {
        draft.localState.currentArticle = article;
      });
      queueArticleRender({
        articleId: article.id,
        articleTitle: article.title,
        html,
      });
    },

    player_info: (payload) => {
      set((draft) => {
        draft.localState.playerInfos[String(payload.id)] = payload;
      });
    },

    setConnectionError: (error) => {
      set((draft) => {
        draft.localState.connectionError = error;
      });
    },
  })),
);
